import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ListItemButton,
} from "@mui/material";
import { Grid2, Button, MenuItem } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import SettingsIcon from "@mui/icons-material/Settings";
import CompanyDetailsCard from "../Micuenta/CompanyDetailsCard";
import BillingDetailsCard from "../Micuenta/BillingDetailsCard";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import IntegracionesEmpresaUI from "../Companies/IntegracionesEmpresaUI/IntegracionesEmpresaUI";

const initialForm = {
  rut: "",
  razonSocial: "",
  nombreFantasia: "",
  direccion: "",
  comuna: "",
  ciudad: "",
  region: "",
  giro: "",
  correo: "",
  telefono: "",
  centroCosto: "",
  formaPago: "",
  diasPago: "",
  contacto: "",
  contactoEmail: "",
  contactoTel: "",
};

const Configuraciones = ({
  userData = null,
  companiesData = null,
  currentCompany = null,
  usuarioStorage = null,
  firebaseUser = null,
  integraciones = [],
  vehicles,
}) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [empresa, setEmpresa] = useState({});
  const [data, setData] = useState(initialForm);
  const [open, setOpen] = useState(false); // dialog abierto
  const [saving, setSaving] = useState(false);

  const [openDocumento, setOpenDocumento] = useState(false);
  const [openNoEntrega, setOpenNoEntrega] = useState(false);
  const [openTarifa, setOpenTarifa] = useState(false);
  const [formDocumento, setFormDocumento] = useState({
    tipoDocumento: "",
    archivo: null,
  });
  const [formNoEntrega, setFormNoEntrega] = useState({
    name: "",
    reasonCode: "",
    intState: "",
  });
  const [formTarifa, setFormTarifa] = useState({ typeDelivery: "", value: "" });

  const [expandedIndex, setExpandedIndex] = useState(null);
  const [selectedEstado, setSelectedEstado] = useState(null);
  const [expandedDocIndex, setExpandedDocIndex] = useState(null);
  const [editingTarifaKey, setEditingTarifaKey] = useState(null);
  useEffect(() => {
    if (userData && companiesData && currentCompany) {
      console.log("desde el Dhas");
      setIsAdmin(false);
    }
    if (usuarioStorage && firebaseUser) {
      console.log("desde el Link");
      //valida Admin
      setIsAdmin(true);
    }
  }, [
    userData && companiesData && currentCompany,
    usuarioStorage && firebaseUser,
  ]);

  const cardStyles = { maxWidth: "50%", width: "50%", maxHeight: "400px" };
  const CardContentStyles = {
    overflow: "hidden",
    overflowY: "scroll",
    maxHeight: "30vh",
  };
  const cardHeaderStyles = {
    backgroundColor: "rgb(89, 30, 143)",
    color: "#fff",
    p: 0.5,
  };
  //OPCIONES DE DOCUMENTOS

  const documentos = [
    { key: "companyImgDocSii", label: "Documento SII" },
    { key: "companyImgRut", label: "Documento RUT" },
    { key: "companyImgPatente", label: "Patente Vehículo" },
    { key: "acuerdocomercial", label: "Acuerdo comercial" },
    { key: "anexosComerciales", label: "Anexo comercial" },
  ];

  //OPCIONES DE ESTADOS

  const handleEdit = () => {
    console.log("Editar:", selectedEstado);
    setExpandedIndex(null);
  };

  const handleDelete = () => {
    console.log("Eliminar:", selectedEstado);
    setExpandedIndex(null);
  };

  const handleActivate = () => {
    console.log("Activar en app conductor:", selectedEstado);
    setExpandedIndex(null);
  };

  // ACCIONES DE TARIFAS
  const handleOpenTarifa = (key = null, data = null) => {
    if (key && data) {
      setFormTarifa({
        typeDelivery: data.typeDelivery || "",
        descriptor: data.descriptor || "",
        vehicleType: data.vehicleType || "",
        value: data.value || "",
      });
      setEditingTarifaKey(key); // ← identificador que estás editando
    } else {
      setFormTarifa({
        typeDelivery: "",
        descriptor: "",
        vehicleType: "",
        value: "",
      });
      setEditingTarifaKey(null); // ← nueva tarifa
    }

    setOpenTarifa(true);
  };

  const handleSubmitTarifa = () => {
    if (editingTarifaKey) {
      console.log("✏️ Actualizando tarifa:", editingTarifaKey, formTarifa);
      // Aquí haces la lógica de update en Firestore o en el objeto local
    } else {
      console.log("➕ Agregando nueva tarifa:", formTarifa);
      // Lógica de inserción
    }

    handleCloseTarifa();
  };

  // INTEGRACIONES

  const InterfazEmpresa = ({ companyData }) => {
    if (!companyData) return;
    return (
      <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h6">Secciones:</Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2,
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Card sx={cardStyles}>
            <CardHeader title="Datos de la empresa" sx={cardHeaderStyles} />

            <CompanyDetailsCard company={currentCompany} />
          </Card>

          <Card sx={cardStyles}>
            <CardHeader
              title="Datos de Facturación"
              action={
                <IconButton
                  onClick={() => handleOpen()}
                  color="primary"
                  sx={{ color: "#fff", fontSize: "1em" }}
                  aria-label="editar datos de facturación"
                >
                  Editar <EditIcon />
                </IconButton>
              }
              sx={cardHeaderStyles}
            />
            <BillingDetailsCard companyBilling={data}></BillingDetailsCard>
            <CardContent sx={CardContentStyles}></CardContent>
          </Card>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2,
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Card sx={cardStyles}>
            <CardHeader
              title="Documentos"
              sx={cardHeaderStyles}
              action={
                <IconButton
                  onClick={() => handleOpenDocumento()}
                  color="primary"
                  sx={{ color: "#fff", fontSize: "1em" }}
                  aria-label="editar datos de facturación"
                >
                  Agregar <AddCircleOutlineIcon />
                </IconButton>
              }
            />

            <CardContent sx={CardContentStyles}>
              <List>
                {documentos.map((doc, index) => {
                  const isUploaded = !!companyData?.[doc.key];

                  return (
                    <React.Fragment key={doc.key}>
                      <ListItem
                        secondaryAction={
                          <IconButton
                            edge="end"
                            size="small"
                            onClick={() =>
                              setExpandedDocIndex(
                                expandedDocIndex === index ? null : index
                              )
                            }
                          >
                            <SettingsIcon />
                          </IconButton>
                        }
                      >
                        <ListItemIcon>
                          <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText primary={doc.label} />
                        {isUploaded ? (
                          <CheckCircleIcon color="success" />
                        ) : (
                          <WarningAmberIcon color="error" />
                        )}
                      </ListItem>

                      {expandedDocIndex === index && (
                        <Box sx={{ pl: 6 }}>
                          <ListItemButton
                            onClick={() => {
                              console.log("📤 Subir documento:", doc.key);
                              setExpandedDocIndex(null);
                            }}
                          >
                            <ListItemText primary="Subir / Actualizar documento" />
                          </ListItemButton>
                          <ListItemButton
                            onClick={() => {
                              console.log("📁 Ver documento:", doc.key);
                              setExpandedDocIndex(null);
                            }}
                          >
                            <ListItemText primary="Ver archivo actual" />
                          </ListItemButton>
                        </Box>
                      )}
                    </React.Fragment>
                  );
                })}
              </List>
            </CardContent>
          </Card>
          <Card sx={cardStyles}>
            <CardHeader
              title="Configurar Estados de No Entrega para Operaciones"
              sx={cardHeaderStyles}
              action={
                <IconButton
                  onClick={() => handleOpenNoEntrega()}
                  color="primary"
                  sx={{ color: "#fff", fontSize: "1em" }}
                  aria-label="editar datos de facturación"
                >
                  Agregar <AddCircleOutlineIcon />
                </IconButton>
              }
            />
            <CardContent sx={CardContentStyles}>
              <List>
                {(companyData?.nonDelivery || []).map((estado, index) => (
                  <React.Fragment key={index}>
                    <ListItem
                      secondaryAction={
                        <IconButton
                          edge="end"
                          size="small"
                          onClick={(e) => {
                            setSelectedEstado(estado);
                            setExpandedIndex(
                              expandedIndex === index ? null : index
                            );
                          }}
                        >
                          <SettingsIcon />
                        </IconButton>
                      }
                    >
                      <ListItemText
                        primary={`Código Motivo: ${estado.reasonCode} | ${estado.name}`}
                        secondary={`Estado Integración: ${estado.state} | Código: ${estado.intState}`}
                      />
                      {/* ${estado.reasonCode} = id | ${estado.name} = reason | createdAt | updatedAt son estado en API conductores */}
                    </ListItem>
                    {expandedIndex === index && (
                      <Box sx={{ pl: 6 }}>
                        <ListItemButton onClick={() => handleEdit(estado)}>
                          <ListItemIcon>
                            <EditIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText primary="Editar" />
                        </ListItemButton>
                        <ListItemButton onClick={() => handleDelete(estado)}>
                          <ListItemIcon>
                            <CancelIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText primary="Eliminar" />
                        </ListItemButton>
                        <ListItemButton onClick={() => handleActivate(estado)}>
                          <ListItemIcon>
                            <CheckCircleIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText primary="Activar en APP conductor" />
                        </ListItemButton>
                      </Box>
                    )}
                  </React.Fragment>
                ))}
              </List>
            </CardContent>
          </Card>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2,
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Card sx={cardStyles}>
            <CardHeader
              title="Configurar Tarifarios"
              sx={cardHeaderStyles}
              action={
                <IconButton
                  onClick={() => handleOpenTarifa()}
                  color="primary"
                  sx={{ color: "#fff", fontSize: "1em" }}
                  aria-label="editar datos de facturación"
                >
                  Agregar <AddCircleOutlineIcon />
                </IconButton>
              }
            />
            <CardContent sx={CardContentStyles}>
              <List>
                {companyData?.serviceRateRider &&
                  Object.entries(companyData.serviceRateRider).map(
                    ([key, rule], index) => (
                      <ListItem key={key || index}>
                        <ListItemIcon
                          onClick={() => handleOpenTarifa(key, rule)}
                        >
                          <EditIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={`Tipo: ${rule.typeDelivery} - Modo: ${
                            vehicles[rule.vehicleType]?.name || "N/A"
                          }`}
                          secondary={`Tarifa: $${rule.value}`}
                        />
                      </ListItem>
                    )
                  )}
              </List>
            </CardContent>
          </Card>
          <IntegracionesEmpresaUI
            currentCompany={currentCompany}
            integrations={integraciones}
          ></IntegracionesEmpresaUI>
        </Box>
      </Box>
    );
  };

  const regiones = [
    "Región Metropolitana",
    "Valparaíso",
    "Biobío",
    "Maule",
    "La Araucanía",
    "Antofagasta",
    "O'Higgins",
    "Los Lagos",
  ];

  const formasPago = [
    "Contado",
    "Transferencia",
    "Crédito 30 días",
    "Crédito 60 días",
  ];

  const [form, setForm] = useState({
    rut: "",
    razonSocial: "",
    nombreFantasia: "",
    direccion: "",
    comuna: "",
    ciudad: "",
    region: "",
    giro: "",
    correo: "",
    telefono: "",
    centroCosto: "",
    formaPago: "",
    diasPago: "",
    contacto: "",
    contactoEmail: "",
    contactoTel: "",
  });

  const handleOpen = () => {
    setForm(data ?? initialForm);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Datos enviados:", form);
    setData(form);
    setOpen(false);
    setSaving(false);
  };

  const handleChangeDocumento = (e) => {
    setFormDocumento({ ...formDocumento, [e.target.name]: e.target.value });
  };

  const handleChangeNoEntrega = (e) => {
    setFormNoEntrega({ ...formNoEntrega, [e.target.name]: e.target.value });
  };

  const handleChangeTarifa = (e) => {
    setFormTarifa({ ...formTarifa, [e.target.name]: e.target.value });
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormDocumento({ ...formDocumento, archivo: file });
    }
  };

  const handleOpenDocumento = () => setOpenDocumento(true);
  const handleOpenNoEntrega = () => setOpenNoEntrega(true);

  const handleCloseDocumento = () => setOpenDocumento(false);
  const handleCloseNoEntrega = () => setOpenNoEntrega(false);
  const handleCloseTarifa = () => setOpenTarifa(false);

  const handleSubmitDocumento = () => {
    console.log("📄 Documento cargado:", formDocumento);
    handleCloseDocumento();
  };

  const handleSubmitNoEntrega = () => {
    console.log("🚫 Estado No Entrega agregado:", formNoEntrega);
    handleCloseNoEntrega();
  };

  return !isAdmin ? (
    <>
      <InterfazEmpresa companyData={currentCompany}></InterfazEmpresa>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Editar datos de facturación</DialogTitle>
        <DialogContent dividers>
          <Grid2 container spacing={2} sx={{ mt: 0.5 }}>
            {/* Ejemplo: los primeros campos ─ repite el resto igual */}
            <Box>
              <Grid2 item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="RUT"
                  name="rut"
                  value={form.rut}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Razón Social"
                  name="razonSocial"
                  value={form.razonSocial}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 item xs={12}>
                <TextField
                  fullWidth
                  label="Nombre de Fantasía"
                  name="nombreFantasia"
                  value={form.nombreFantasia}
                  onChange={handleChange}
                />
              </Grid2>
            </Box>
            <Box>
              <Grid2 item xs={12}>
                <TextField
                  fullWidth
                  label="Dirección Comercial"
                  name="direccion"
                  value={form.direccion}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Comuna"
                  name="comuna"
                  value={form.comuna}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Ciudad"
                  name="ciudad"
                  value={form.ciudad}
                  onChange={handleChange}
                />
              </Grid2>
            </Box>
            <Box>
              <Grid2 item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  label="Región"
                  name="region"
                  value={form.region}
                  onChange={handleChange}
                  sx={{ minWidth: "200px" }}
                >
                  {regiones.map((r) => (
                    <MenuItem key={r} value={r}>
                      {r}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid2>
              <Grid2 item xs={12}>
                <TextField
                  fullWidth
                  label="Giro / Actividad"
                  name="giro"
                  value={form.giro}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Correo Facturación"
                  name="correo"
                  value={form.correo}
                  onChange={handleChange}
                />
              </Grid2>
            </Box>
            <Box>
              <Grid2 item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Teléfono"
                  name="telefono"
                  value={form.telefono}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Centro de Costo"
                  name="centroCosto"
                  value={form.centroCosto}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  label="Forma de Pago"
                  name="formaPago"
                  value={form.formaPago}
                  onChange={handleChange}
                  sx={{ minWidth: "200px" }}
                >
                  {formasPago.map((fp) => (
                    <MenuItem key={fp} value={fp}>
                      {fp}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid2>
            </Box>
            <Box>
              <Grid2 item xs={12}>
                <TextField
                  fullWidth
                  label="Días de Pago"
                  name="diasPago"
                  value={form.diasPago}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Contacto"
                  name="contacto"
                  value={form.contacto}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Email"
                  name="contactoEmail"
                  value={form.contactoEmail}
                  onChange={handleChange}
                />
              </Grid2>

              <Grid2 item xs={12}>
                <TextField
                  fullWidth
                  label="Teléfono"
                  name="contactoTel"
                  value={form.contactoTel}
                  onChange={handleChange}
                />
              </Grid2>
            </Box>
          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleSubmit} variant="contained" disabled={saving}>
            {saving ? "Guardando…" : "Guardar"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDocumento}
        onClose={handleCloseDocumento}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Subir documento</DialogTitle>
        <DialogContent dividers>
          <Grid2 container spacing={2}>
            <Grid2 item xs={12}>
              <TextField
                select
                fullWidth
                label="Tipo de documento"
                name="tipoDocumento"
                value={formDocumento.tipoDocumento}
                onChange={handleChangeDocumento}
                sx={{ minWidth: "200px" }}
              >
                {documentos.map((doc) => (
                  <MenuItem key={doc.key} value={doc.key}>
                    {doc.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid2>
            <Grid2 item xs={12}>
              <Button variant="outlined" component="label" fullWidth>
                Seleccionar archivo
                <input type="file" hidden onChange={handleFileUpload} />
              </Button>
            </Grid2>
          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDocumento}>Cancelar</Button>
          <Button onClick={handleSubmitDocumento} variant="contained">
            Subir
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openNoEntrega}
        onClose={handleCloseNoEntrega}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Agregar estado de no entrega</DialogTitle>
        <DialogContent dividers>
          <Grid2 container spacing={2}>
            <Grid2 item xs={12}>
              <TextField
                fullWidth
                label="Nombre del estado"
                name="name"
                value={formNoEntrega.name}
                onChange={handleChangeNoEntrega}
              />
            </Grid2>
            <Grid2 item xs={6}>
              <TextField
                fullWidth
                label="Código externo"
                name="reasonCode"
                value={formNoEntrega.reasonCode}
                onChange={handleChangeNoEntrega}
              />
            </Grid2>
            <Grid2 item xs={6}>
              <TextField
                fullWidth
                label="Estado interno"
                name="intState"
                value={formNoEntrega.intState}
                onChange={handleChangeNoEntrega}
              />
            </Grid2>
          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNoEntrega}>Cancelar</Button>
          <Button onClick={handleSubmitNoEntrega} variant="contained">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openTarifa}
        onClose={handleCloseTarifa}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Agregar tarifa</DialogTitle>
        <DialogContent dividers>
          <Grid2 container spacing={2}>
            <Grid2 item xs={12}>
              <TextField
                fullWidth
                label="Tipo de entrega"
                name="typeDelivery"
                value={formTarifa.typeDelivery}
                onChange={handleChangeTarifa}
              />
            </Grid2>
            <Grid2 item xs={12}>
              <TextField
                fullWidth
                label="Descriptor"
                name="descriptor"
                value={formTarifa.descriptor}
                onChange={handleChangeTarifa}
              />
            </Grid2>
            <TextField
              select
              fullWidth
              label="Tipo de Vehículo"
              name="vehicleType"
              value={formTarifa.vehicleType}
              onChange={handleChangeTarifa}
              sx={{ minWidth: "200px" }}
            >
              {Object.keys(vehicles).map((vehicle) => (
                <MenuItem key={vehicle} value={vehicles[vehicle].id}>
                  {vehicles[vehicle].name}
                </MenuItem>
              ))}
            </TextField>
            <Grid2 item xs={12}>
              <TextField
                fullWidth
                type="number"
                label="Tarifa ($)"
                name="value"
                value={formTarifa.value}
                onChange={handleChangeTarifa}
              />
            </Grid2>
          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTarifa}>Cancelar</Button>
          <Button onClick={handleSubmitTarifa} variant="contained">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  ) : (
    <Box sx={{ width: "100%", textAlign: "center", p: 20 }}>
      <Card sx={{ maxWidth: "350px", p: 1 }}>
        <div>
          <Typography sx={{ color: "red", fontSize: "2em" }}>
            No tiene permisos suficiente.
          </Typography>
          <Typography sx={{ color: "blue", fontSize: "1em" }}>
            Puede Configurar su empresa en la sección de empresas
          </Typography>
        </div>
      </Card>
    </Box>
  );
};

export default Configuraciones;
